export default function humanFileSize(bytes) {
  const threshold = 1000;
  if (Math.abs(bytes) < threshold) {
    return bytes + " B";
  }
  const units = ["kB", "MB", "GB", "TB"];
  let u = -1;
  do {
    bytes /= threshold;
    ++u;
  } while (Math.abs(bytes) >= threshold && u < units.length - 1);
  return bytes.toFixed(1) + " " + units[u];
}
